<div class="screen" [ngClass]="{ 'solid-background': useSolidBackground$ | async }">
  <div
    class="overlay"
    [@overlayTrigger]="state"
    [ngStyle]="{ 'width.px': width, 'height.px': height }"
    >
    @if (headerAvatar) {
      <div class="overlay-header-avatar">
        <cm-avatar-thumb
          [user]="headerAvatar"
          size="140"
          [hidePresence]="true"
        ></cm-avatar-thumb>
      </div>
    }
    @if (header) {
      <div
        class="overlay-header"
        [ngClass]="{ center: headerCenter }"
        >
        {{ header }}
        @if (showMessageCount) {
          <cm-message-count
            [totalMessages]="totalMessages"
            [currentMessage]="currentMessage"
          ></cm-message-count>
        }
      </div>
    }
    <div class="overlay-content" [ngClass]="{ 'justify-top': justifyTop }">
      <ng-content></ng-content>
    </div>
  </div>
</div>
